var moment = require('moment');
var module = angular.module('octopusApp.projects');

module.directive('projectPulse', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      pulse: '=pulse'
    },
    templateUrl: 'areas/projects/views/pulse.html',
    controller: function($scope) {
      // Could be better off as a filter
      $scope.pulseFreshnessClass = function() {
        var none = 'none';
        var freshnessClasses = [[1, 'super'], [7, 'fresh'], [30, 'stale'], [120, 'old'], [null, 'ancient']];
        var freshness = none;

        if ($scope.anyPulse()) {
          var deployed = moment($scope.pulse.Deployed);
          var days = moment().diff(deployed, 'days');
          for (var i = 0; i < freshnessClasses.length; ++i) {
            var f = freshnessClasses[i];
            var bracket = f[0];
            if (!bracket || (days < bracket)) {
              freshness = f[1];
              break;
            }
          }
        }

        return 'pulse-freshness-' + freshness;
      };

      $scope.anyPulse = function() {
        return $scope.pulse && $scope.pulse.MostSignificantDeploymentId;
      };
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/project_pulse.js
// module id = 1539520993084937
// module chunks = 1